import { IconButton, Tooltip, useMediaQuery } from '@mui/material';
import { useTheme } from '@nohara/react-theme';
import { useEffect } from 'react';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTranslation } from 'react-i18next';

export const ThemeToggle = () => {
  const { mode, toggleTheme, setMode } = useTheme();
  const { t } = useTranslation();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  // Set theme based on system preference on initial load
  useEffect(() => {
    const savedMode = window.localStorage.getItem('theme-mode');
    if (savedMode) {
      setMode(savedMode as 'light' | 'dark');
    } else if (prefersDarkMode) {
      setMode('dark');
    }
  }, [prefersDarkMode, setMode]);

  // Save theme preference to localStorage
  useEffect(() => {
    window.localStorage.setItem('theme-mode', mode);
  }, [mode]);

  const tooltipTitle =
    mode === 'light'
      ? t('theme.switchToDark', 'Switch to dark mode')
      : t('theme.switchToLight', 'Switch to light mode');

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton onClick={toggleTheme} color='inherit' aria-label='toggle theme'>
        {mode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  );
};
